import { ModalViewProduct } from "Pages/Product/Modals/ViewProduct";

import { Product } from "Hooks/useProducts/interface";

import { Button } from "Components/Button";
import AtentionIcon from "Assets/Images/atention.svg";
import { Modal } from "Components/Modals/Modal";
import { Box } from "styles/globalComponents";
import { CardProduct } from "Components/PreOrder/CardProduct";
import { ModalConfirm } from "Components/Modals/ModalConfirm";
import { useResultProductList } from "Pages/ClientBudgetService/hooks/useResultProductsList";
import { ContainerProductList } from "./styles";

interface ProductsListResultProps {
  productsList: Product[];
}

export const ProductsListResult = ({
  productsList,
}: ProductsListResultProps) => {
  const {
    cancelAddProduct,
    goToTypeForm,
    openProductDetails,
    proceedAddProduct,
    modalViewInfoProduct,
    productDetailId,
    handleAddProduct,
    handleRemoveToCart,
    closeModal,
    setModalViewInfoProduct,
    modal,
    preparation,
    data,
    blockInteraction,
  } = useResultProductList();

  return (
    <>
      <ContainerProductList className="products-results">
        <table>
          <thead>
            <tr>
              <th>SKU</th>
              <th>PRODUTO</th>
              <th>SINONÍMIA</th>
              <th>VALOR</th>
              <th>AÇÕES</th>
            </tr>
          </thead>

          <tbody>
            {productsList.map((product) => (
              <CardProduct
                key={product.id}
                product={product}
                addToCart={() => handleAddProduct(product)}
                removeToCart={() => handleRemoveToCart(product)}
                blockUserInteraction={blockInteraction}
                isProductAlredyInCart={
                  !!data?.cart.some((d) => d.product_id === product.id)
                }
              >
                <Button
                  outlined
                  onClick={() => openProductDetails(product.id)}
                  disabled={blockInteraction}
                >
                  {" "}
                  Saiba Mais
                </Button>
              </CardProduct>
            ))}
          </tbody>
        </table>
      </ContainerProductList>

      <Modal
        isOpen={modal.alerts}
        requestClose={cancelAddProduct}
        closeOverlay
        modalIcon={AtentionIcon}
        renderHeading={() => <h2>Alerta</h2>}
        renderDescription={() => <p>{preparation}</p>}
        renderActions={() => (
          <Box>
            <Box display="flex" justify="center" mt="30">
              <Button minHeight="40px" onClick={proceedAddProduct}>
                Adicionar produto
              </Button>

              <Button minHeight="40px" outlined onClick={cancelAddProduct}>
                Cancelar adição do produto
              </Button>
            </Box>
          </Box>
        )}
      />

      <ModalConfirm
        modalVisible={modal.unavailable}
        modalDismiss={() => closeModal("unavailable")}
        handleClick={goToTypeForm}
        text="Adicionar"
        title="Este produto está no momento está em lista de espera, deseja adicionar o cliente a lista?"
      />

      <ModalViewProduct
        openModal={modalViewInfoProduct}
        closeModal={() => setModalViewInfoProduct(false)}
        idSelected={productDetailId}
      />
    </>
  );
};
